import type { SummonKind } from "../../../data/portal-ffa-catalog";
import { ArtPipeline } from "../../../art";
import { t } from "../../../data/strings";
import type {
  HudSnapshot,
  SummonRequestResult,
  WorldState,
} from "../../../features/portal-ffa";
import {
  ART_PACK,
  costHtml,
  failTitle,
} from "./markup";

export function applySummonFeedback(
  btn: HTMLButtonElement,
  result: SummonRequestResult,
): void {
  btn.classList.remove("is-ok", "is-fail", "is-queued");
  if (result.status === "spawned") btn.classList.add("is-ok");
  else if (result.status === "queued") btn.classList.add("is-queued");
  else btn.classList.add("is-fail");
  window.setTimeout(() => {
    btn.classList.remove("is-ok", "is-fail", "is-queued");
  }, 280);
}

export type SummonDockHandle = {
  syncAfford: (world: WorldState, snap: HudSnapshot) => void;
  feedbackSummon: (kind: SummonKind, result: SummonRequestResult) => void;
};

export function mountSummonDock(
  parent: HTMLElement,
  kinds: SummonKind[],
  onSummon: (kind: SummonKind) => SummonRequestResult | void,
  showToast: (text: string) => void,
): SummonDockHandle {
  const dockGrid = document.createElement("div");
  dockGrid.className = "ffa-dock-grid";
  parent.appendChild(dockGrid);

  for (const kind of kinds) {
    const btn = document.createElement("button");
    btn.type = "button";
    btn.className = "ffa-summon";
    btn.dataset.kind = kind;
    const iconUrl = ArtPipeline.spriteDataUrl(ART_PACK, kind, "ally", 2);
    btn.innerHTML = `<img class="ffa-summon-icon" alt="" src="${iconUrl}" /><span>${t(`unit.${kind}`)}</span><small class="ffa-summon-cost" data-cost>${costHtml(kind)}</small>`;
    btn.addEventListener("click", (ev) => {
      ev.stopPropagation();
      btn.classList.remove("is-ok", "is-fail", "is-queued");
      btn.classList.add("is-press");
      window.setTimeout(() => btn.classList.remove("is-press"), 120);
      const result = onSummon(kind);
      if (result) feedbackSummon(kind, result);
    });
    dockGrid.appendChild(btn);
  }

  const feedbackSummon = (
    kind: SummonKind,
    result: SummonRequestResult,
  ): void => {
    const btn = dockGrid.querySelector(
      `[data-kind="${kind}"]`,
    ) as HTMLButtonElement | null;
    if (btn) applySummonFeedback(btn, result);
    if (result.status === "rejected") {
      showToast(failTitle(result.reason));
    } else if (result.status === "queued") {
      showToast(t("hud.msgQueued"));
    }
  };

  return {
    syncAfford: (_world: WorldState, snap: HudSnapshot) => {
      for (const kind of kinds) {
        const btn = dockGrid.querySelector(
          `[data-kind="${kind}"]`,
        ) as HTMLButtonElement | null;
        if (!btn) continue;
        const reason = snap.canAfford[kind];
        btn.disabled = reason !== null;
        btn.title = reason ? failTitle(reason) : "";
      }
    },
    feedbackSummon,
  };
}
